import { createSlice } from '@reduxjs/toolkit';

export const ContentUploadForVoucherSlice = createSlice({
  name: 'ContentUpload',
  initialState: {
    ContentUpload: {},
    loading: false,
  },
  reducers: {
    UPLOAD_CONTENT_REQUEST: (state) => {
      state.loading = true;
    },
    UPLOAD_CONTENT_SUCCESS: (state, action) => {
      state.loading = false;
      state.ContentUpload = action.payload;
    },
    UPLOAD_CONTENT_FAIL: (state, action) => {
      state.loading = false;
      state.ContentUpload = action.payload;
    },
    CLEAR_ERRORS: (state) => {
      state.error = null;
    },
  },
});

export const {
  UPLOAD_CONTENT_REQUEST,
  UPLOAD_CONTENT_SUCCESS,
  UPLOAD_CONTENT_FAIL,
  CLEAR_ERRORS,
} = ContentUploadForVoucherSlice.actions;

export default ContentUploadForVoucherSlice.reducer;


